var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "#57454A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 37.75H21.0833V33.5833H25.25V37.75ZM21.0833 23.1667H16.9167V33.5833H21.0833V23.1667ZM37.75 19H33.5833V27.3333H37.75V19ZM33.5833 14.8333H29.4167V19H33.5833V14.8333ZM8.58333 19H4.41667V23.1667H8.58333V19ZM4.41667 14.8333H0.25V19H4.41667V14.8333ZM19 4.41667H23.1667V0.25H19V4.41667ZM3.375 3.375V9.625H9.625V3.375H3.375ZM12.75 12.75H0.25V0.25H12.75V12.75ZM3.375 28.375V34.625H9.625V28.375H3.375ZM12.75 37.75H0.25V25.25H12.75V37.75ZM28.375 3.375V9.625H34.625V3.375H28.375ZM37.75 12.75H25.25V0.25H37.75V12.75ZM33.5833 33.5833V27.3333H25.25V31.5H29.4167V37.75H37.75V33.5833H33.5833ZM29.4167 19H21.0833V23.1667H29.4167V19ZM21.0833 14.8333H8.58333V19H12.75V23.1667H16.9167V19H21.0833V14.8333ZM23.1667 12.75V8.58333H19V4.41667H14.8333V12.75H23.1667ZM8.0625 4.9375H4.9375V8.0625H8.0625V4.9375ZM8.0625 29.9375H4.9375V33.0625H8.0625V29.9375ZM33.0625 4.9375H29.9375V8.0625H33.0625V4.9375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c28686083cafb01db8c5f7bc18031195.svg";
export { ForwardRef as ReactComponent };